import React, { useContext, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { TipoDocsContext } from "../TipoDocsContext";
import Formulario from "../../../../../Components/Cadastro/Formulario/Formulario";
import FormularioComplementar from '../../../../../Components/Cadastro/FormularioComplementar/FormularioComplementar';
import DataTable from '../../../../../Components/DataTable/DataTable';
import { removeItemFromArray } from '../../../../../Utils/globalFunctions';

const FormularioTipoDocs = () => {
  const { values, setValues,
    getDetailHandler } = useContext(
      TipoDocsContext
    );
  let { id } = useParams();

  useEffect(() => {
    getDetailHandler(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columnsDefinitionSubtipos = [
    { text: 'Id', dataField: 'subTipoDocsId', hidden: true },
    {
      text: 'Subtipo',
      dataField: 'subTipoDocsNome',
      headerStyle: { width: '450px' },
      sort: true
    },
    {
      text: 'Status',
      dataField: 'subTipoDocsStatus',
      headerStyle: { width: '120px' },
      sort: true,
      formatter: (cell) =>
        cell === 'A'
          ? <span className="badge badge-success">Ativo</span>
          : <span className="badge badge-danger">Inativo</span>
    }
  ];

  const onChangeInputSubtipos = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      dataSubtipo: {
        ...(values.dataSubtipo || { subTipoDocsId: 0, subTipoDocsNome: "", subTipoDocsStatus: "" }),
        [name]: value
      }
    });
  };

  const defaultDataSubtipo = {
    subTipoDocsId: 0,
    subTipoDocsNome: "",
    subTipoDocsStatus: ""
  };

  const adicionarSubtipo = () => {
    const nome = (values?.dataSubtipo?.subTipoDocsNome || "").trim();
    const status = (values?.dataSubtipo?.subTipoDocsStatus || "A").toUpperCase();
    if (!nome) return;

    const lista = Array.isArray(values.data?.subTipoDocsList)
      ? [...values.data.subTipoDocsList]
      : [];

    const existentes = lista.map((s) => (s.id ?? s.subTipoDocsId ?? 0));
    const minAtual = existentes.length ? Math.min(...existentes) : 0;
    const tempId = minAtual < 0 ? minAtual - 1 : -1;

    const novo = {
      id: tempId,
      subTipoDocsId: 0,
      subTipoDocsNome: nome,
      subTipoDocsStatus: status,
    };

    lista.push(novo);

    setValues({
      ...values,
      data: { ...values.data, subTipoDocsList: lista },
      dataSubtipo: { subTipoDocsId: 0, subTipoDocsNome: "", subTipoDocsStatus: "" },
    });
  };


  const removerSubtipo = (id) => {

    var subTipoDocsListNew = values.data.subTipoDocsList;
    removeItemFromArray(subTipoDocsListNew, subTipoDocsListNew.find((subTipoDoc) => subTipoDoc.id === id));

    setValues({
      ...values,
      dataSubtipo: defaultDataSubtipo,
      data: {
        ...values.data,
        subTipoDocsList: subTipoDocsListNew
      }
    });
  };

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      data: {
        ...values.data,
        [name]: value,
      },
    });
  }
  return (
    <Fragment>
      <Formulario context={TipoDocsContext}>
        <div className="col-12 col-md-5 form-group">
          <label>Nome</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength="30"
            name="tipoDocsNome"
            value={values.data.tipoDocsNome}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-2 form-group">
          <label>Status</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="tipoDocsStatus"
            value={values.data.tipoDocsStatus}
            onChange={onChangeInput}
          >
            <option className="disabled"></option>
            <option value="A"> Ativo </option>
            <option value="I"> Inativo </option>
          </select>
        </div>
      </Formulario>

      <FormularioComplementar titulo="Sub Tipos">
        <div className="col-12 col-md-6 form-group">
          <label>Nome</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength="50"
            name="subTipoDocsNome"
            value={values.dataSubtipo?.subTipoDocsNome || ""}
            onChange={onChangeInputSubtipos}
          />
        </div>

        <div className="col-12 col-md-2 form-group">
          <label>Status</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="subTipoDocsStatus"
            value={values.dataSubtipo?.subTipoDocsStatus || ""}
            onChange={onChangeInputSubtipos}
          >
            <option className="disabled" />
            <option value="A">Ativo</option>
            <option value="I">Inativo</option>
          </select>
        </div>

        <div className="col-12 col-md-2 form-group">
          <button
            disabled={
              values.formDisabled ||
              !(values.dataSubtipo?.subTipoDocsNome) ||
              !(values.dataSubtipo?.subTipoDocsStatus)
            }
            style={{ marginTop: '26px' }}
            type="button"
            className="btn btn-default buttonFormularios"
            onClick={adicionarSubtipo}
          >
            Adicionar
          </button>
        </div>

        <div className="col-12 col-md-12 form-group">
          <DataTable
            data={values.data?.subTipoDocsList || []}
            columnsDefinition={columnsDefinitionSubtipos}
            removeHandler={values.formDisabled ? null : removerSubtipo}
          />
        </div>
      </FormularioComplementar>

    </Fragment>
  );
};

export default FormularioTipoDocs;
